import Cesium from "cesium";

import CesiumPolylineExtender from "../util/markers/cesiumPolylineExtender";

const extendCesiumObjects = function() {
  // DONE: Move!
  if (window.OVERRIDE_SKIP_LDAP !== true && process.env.CHANNEL !== "offline") {
    const oldCreateIfNeeded = Cesium.Resource.createIfNeeded;
    Cesium.Resource.createIfNeeded = function (resource) {
      const res = oldCreateIfNeeded(resource);
      if (res && typeof res.url === "string" && res.url.indexOf("newayz.com") >= 0) {
        if (!res.headers) {
          res.headers = {};
        }

        const ACCESS_TOKEN = localStorage.getItem('ACCESS_TOKEN') ? localStorage.getItem('ACCESS_TOKEN') : '';
        res.headers["access_token"] = ACCESS_TOKEN;
      }

      return res;
    };
  }

  Object.defineProperty(Cesium.Primitive.prototype, "markerGroup", {
    get() {
      return this._markerGroup;
    },
    set(val) {
      // console.assert(val instanceof MarkerGroup, "val is not MarkerGroup!");
      this._markerGroup = val;
    }
  });

  Object.defineProperty(Cesium.Primitive.prototype, "userData", {
    get() {
      return this._userData;
    },
    set(val) {
      this._userData = val;
    }
  });

  Object.defineProperty(Cesium.Entity.prototype, "markerGroup", {
    get() {
      return this._markerGroup;
    },
    set(val) {
      // console.assert(val instanceof MarkerGroup, "val is not MarkerGroup!");
      this._markerGroup = val;
    }
  });

  Object.defineProperty(Cesium.Entity.prototype, "userData", {
    get() {
      return this._userData;
    },
    set(val) {
      this._userData = val;
    }
  });

};

export default function init() {
  // DONE: Should make sure these Cesium class extending functions only get called once!
  extendCesiumObjects();
  CesiumPolylineExtender.extendPolyline();
}


// WEBPACK FOOTER //
// ./src/initManager/index.js